import StripeConnect from './StripeConnect';

export default StripeConnect;
